import { v7 as uuidv7 } from 'uuid';

import { getItem } from './storage.js';

export const nrkContext = {
  nrkSession: nrkSession(),
};
export const environment = import.meta.env.VITE_APP_ENV;
export const adminApiUrl = import.meta.env.VITE_ADMIN_API_URL || '';

function nrkSession() {
  return getItem<string>('session', 'nrk-session-id', uuidv7());
}
